export default {
  index() {
    return {
      endpoint: `/api/v1/licenses`,
      method: "GET",
      options: {}
    };
  }
};
